<template>
  <div class="side_toolbar">
    <div v-show="scrollTag" @click="goTop" class="go_top"> </div>
    <div @click="goService" class="service"></div>
    <div class="qr_code">
      <div class="bg_box">
        <img src="@/assets/img/sideToolbar/ewx.png" alt="">
        <span>关注公众号</span>
      </div>
    </div>
    <div v-if="false" class="note">
    </div>
  </div>
</template>

<script>
export default {
  name: "SideToolbar",
  data() {
    return {
      scrollTag: false,
      scrollTop: 30
    };
  },

  mounted() {
    let _this = this;
    window.addEventListener("scroll", () => {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      this.scrollTop = top;
      if (top > 460) {
        this.scrollTag = true;
      } else {
        this.scrollTag = false;
      }
    });
  },

  methods: {
    goTop() {
      /**
       * 滚动到顶部
       */
      let $this = this;
      // 返回顶部动画特效
      setTimeout(function animation() {
        if ($this.scrollTop > 0) {
          setTimeout(() => {
            // 步进速度
            $this.scrollTop = $this.scrollTop - 30;

            // 返回顶部
            if (document.documentElement.scrollTop > 0) {
              document.documentElement.scrollTop = $this.scrollTop - 30;
            } else if (window.pageYOffset > 0) {
              window.pageYOffset = $this.scrollTop - 30;
            } else if (document.body.scrollTop > 0) {
              document.body.scrollTop = $this.scrollTop - 30;
            }

            animation();
          }, 1);
        }
      }, 1);
    },
    goService() {
      window.open("https://url.cn/D1LRxZe2?_type=wpa&qidian=true", "_blank");
    }
  }
};
</script>

<style lang='less' scoped>
.side_toolbar {
  width: 70px;
  position: fixed;
  right: 10%;
  top: 60%;
  z-index: 9999;

  div {
    cursor: pointer;
    width: 70px;
    height: 70px;
    border: 1px solid #ccc;
    margin: 2px 0;
    background-color: #fff;
    border-radius: 6px;
  }

  div:hover {
    box-shadow: 0 0 2px #fff;
    border-color: #24ba58;
    background-color: #24ba58;
  }

  .go_top {
    background-image: url("~@/assets/img/sideToolbar/gotop.png");
    background-repeat: no-repeat;
    background-size: 32px 32px;
    background-position: 19px;
  }

  .go_top:hover {
    background-image: url("~@/assets/img/sideToolbar/gotop_active.png");
  }

  .service {
    background-image: url("~@/assets/img/sideToolbar/kefu.png");
    background-repeat: no-repeat;
    background-size: 32px 32px;
    background-position: 19px;
  }

  .service:hover {
    background-image: url("~@/assets/img/sideToolbar/kefu_active.png");
  }

  .qr_code {
    background-image: url("~@/assets/img/sideToolbar/erweima.png");
    background-repeat: no-repeat;
    background-size: 32px 32px;
    background-position: 19px;
    position: relative;

    .bg_box {
      width: 160px;
      height: 200px;
      padding: 10px;
      color: #333;
      border: 1px solid #e0e0e0;
      position: absolute;
      top: -5px;
      left: -165px;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 120px;
        height: 120px;
        background-color: pink;
        margin-bottom: 8px;
      }
    }
  }

  .qr_code:hover {
    background-image: url("~@/assets/img/sideToolbar/erweima_active.png");

    .bg_box {
      display: flex;
      background-color: #fff;
    }
  }

  .note {
    background-image: url("~@/assets/img/sideToolbar/biji.png");
    background-repeat: no-repeat;
    background-size: 32px 32px;
    background-position: 19px;
  }

  .note:hover {
    background-image: url("~@/assets/img/sideToolbar/biji_active.png");
  }
}
</style>